// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e7f082bb","817":"064f9c73"}[chunkId] + ".chunk.js";
};